import React from 'react';
import Text from '../../shared/Text';
import SuccessIcon from './logo-icon/SuccessIcon';
import { CenteredErrorMessage, SimpleErrorMessage } from './shared-form-components';

const SsoAuthLoginSuccessCp3: React.FC = () => {
  const isElectron = navigator.userAgent.indexOf('Electron') >= 0;

  React.useEffect(() => {
    document.title = Text.get('sso_doc_title_success');
  }, []);

  return (
    <div>
      {isElectron ? (
        <CenteredErrorMessage icon={SuccessIcon} errorMessages={['ssoAuthSignIn_success_browser']} />
      ) : (
        <SimpleErrorMessage errorMessages="ssoAuthSignIn_success_browser" />
      )}
    </div>
  );
};

export default SsoAuthLoginSuccessCp3;
